import t from '@instructure/quiz-i18n/format-message';
import { extractTextFromHtml } from '@instructure/quiz-interactions';
export var quizLogMsgErrorDuringTaking = function quizLogMsgErrorDuringTaking(stem) {
  var normalizedStem = stem !== null && stem !== void 0 ? stem : 'Unknown stem';
  var extractedText = extractTextFromHtml(normalizedStem);
  return t('Error while answering "{stem}": Full functionality of the Rich Content Editor may not have been available to the user.', {
    stem: extractedText
  });
};
export var quizLogMsgInvalidParams = function quizLogMsgInvalidParams() {
  return t('Error: Full functionality of the Rich Content Editor may not have been available to the user.');
};
export var quizLogMsgFailedConfigFetch = function quizLogMsgFailedConfigFetch() {
  return t('Error: Full functionality of the Rich Content Editor including accessibility features may not have been available to the user.');
};
export var userAlertMsgTaking = function userAlertMsgTaking() {
  return t('The Rich Content Editor has encountered an issue. It has been logged for your instructor to review. Please refresh and try again.');
};
export var userAlertMsgBuilding = function userAlertMsgBuilding() {
  return t('The Rich Content Editor has encountered an issue. Please refresh and try again.');
};